<template>
	<div class="sale-detail-send-wrap">
		<div style="display: flex;justify-content: space-between;">
			<h2 class="title">发货记录</h2>
			<div 
				style="padding: 32px 16px 16px;font-size: 12px;text-decoration: underline;" 
				@click="openAll"
				 v-if="data.length > 0"
			>全部展开</div>
		</div>
		<van-collapse v-model="activeNames"  v-if="data.length > 0">
		  <van-collapse-item  v-for="(v, i) in data" :name="i + ''">
		    <template #title>
		      <div class="coll-item-title-main">
		      	<div>{{ v.batch }}</div>
		    		<!-- 出库时间 -->
		      	<div>{{ v.createtime_text }}</div>
		      </div>
		      
		      <!-- <div class="coll-item-title-part">
		      	<span>操作人: Roy</span>
		      </div> -->
		    </template>
		    <div class="detail-item"><div class="detail-label">批&nbsp;&nbsp;次&nbsp;&nbsp;号：</div>  {{ v.batch }}</div>
				<div style="margin: 8px 0px;">
					<p>SKU:</p>
					<div 
						style="padding: 8px;" 
						v-for="(sku, sku_i) in v.list"
						:key="'sku' + sku_i"
					>
						<p>{{ sku.sku }}</p>
						
						<div style="font-size: 12px;" class="sku-info-content">
							<div><span style="color: #516c78;"><i class="el-icon-help"></i> </span>Origin: {{ sku.origin }}</div>
							<div><span style="color: #516c78;"><i class="el-icon-help"></i></span>Description: {{ sku.description }}</div>
							<div><span style="color: #516c78;"><i class="el-icon-help"></i></span>Dimension(CM): {{ sku.dimension }}</div>
							<div><span style="color: #516c78;"><i class="el-icon-help"></i></span>GW(KG): {{ sku.gross_weight }}</div>
							<div><span style="color: #516c78;"><i class="el-icon-help"></i></span>Quantity: {{ sku.send_total }}</div>
<!-- 							<div>GW(KG)：{{ sku.warehouse }}</div>
							<div>出库数量：<span style="color: #18bc9c;">{{ sku.outstocknum }}</span></div> -->
						</div>
						
						<hr style="opacity: 0.5;" v-if="sku_i < (v.list.length - 1)">
					</div>
				</div>
		    <div class="detail-item"><div class="detail-label">运输方式：</div> {{ $option.getText($option.transtype, v.trans_type.toString()) }} </div>
		    <div class="detail-item"><div class="detail-label">送货方式：</div>  {{ $option.getText($option.deliverymethods, v.delivery.toString()) }}</div>
		    <div class="detail-item"><div class="detail-label">物流公司：</div>  {{ v.logistic_name }}</div>
		    <div class="detail-item"><div class="detail-label">物流单号：</div> {{ v.courier }}</div>
		    <div class="detail-item"><div class="detail-label">物流费用：</div>  {{ v.shipping }}</div>
		    <div class="detail-item"><div style="display: inline-block;">收件人(Ship to)：</div>  {{ v.receiver }}</div>
		    <div class="detail-item"><div style="display: inline-block;">联系电话(Ship to Tel&Attn)：</div>  {{ v.phone }}</div>
		    <div class="detail-item"><div style="display: inline-block;">收货地址(Ship to Add)：</div> {{ v.address }}</div>
		  </van-collapse-item>
			
		</van-collapse>
		<div
			v-else
			style="height: 50px;background-color: white;line-height: 50px;text-align: center;border-radius: 5px;"
		>暂无数据</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
			id: {
				type: [String, Number],
				default: () => {
					return 0;
				}
			},
		},
		data() {
		  return {
				activeNames: [],
				data: [],
		  };
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		  init() {
				this.getData();
			},
			getData() {
				this.$post(this.$api.stGetFaHuoSendlog, { id: this.id }).then((res) => {
					if (res.code === 1) {
						this.data = res.data.rows;
					} else {
						this.$toast.fail(res.msg ? res.msg : '请求异常');
					}
				}).catch((err) => {
					this.$toast.fail(err);
				});
			},
			// 全部展开  折叠
			openAll() {
				for (let i in this.data) {
					if (!this.activeNames.includes(i)) {
						this.activeNames.push(i);
					}
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.sale-detail-send-wrap {
		margin: 24px;
		border-radius: 5px;
		.title {
				margin: 0;
				padding: 32px 16px 16px;
				color: rgba(69, 90, 100, 0.6);
				font-weight: normal;
				font-size: 14px;
				line-height: 16px;
		}
		
		.coll-item-title-main {
			display: flex;
			justify-content: space-between;
		}
		
		.coll-item-title-part {
			span {
				margin-right: 8px;
				font-size: 12px;
				color: #a5a0a0;
			};
		}
		
		.detail-label {
			width: 80px;
			text-align: left;
			display: inline-block;
		}
		
		.detail-item {
			margin-top: 8px;
		}
		
		.sku-info-content {
			overflow: hidden;
			div {
				float: left;
				margin-right: 12px;
			}
			
		}
	}
</style>